import { differenceInCalendarDays, parseISO } from 'date-fns'

// SINGLE SOURCE OF TRUTH for bizSAFE expiry, renewal status, and urgency.
// Used by Jobs, Quotations, bizSAFE Tracker, Dashboard and Clients — no module re-derives this.
//
// Renewal vs New is determined ONLY by the presence of a bizSAFE expiry (NOT application_type).
// Canonical value = the client's bizsafe_expiry_date, with a fallback to a questionnaire-submitted
// ISO expiry for records that don't yet have a client cert on file (prospects/quotes).

const ISO = /^\d{4}-\d{2}-\d{2}/

export function resolveExpiry(client, formResponses) {
  if (client && client.bizsafe_expiry_date) return client.bizsafe_expiry_date
  const f = formResponses && formResponses.expiry_date
  return f && ISO.test(String(f)) ? f : null
}

export const isRenewal = (client, formResponses) => !!resolveExpiry(client, formResponses)

export function daysToExpiry(dateStr) {
  if (!dateStr) return null
  try { const d = differenceInCalendarDays(parseISO(dateStr), new Date()); return Number.isNaN(d) ? null : d }
  catch (e) { return null }
}

// ONE urgency rule, applied everywhere:
//   overdue → red, ≤30d → red (urgent), 31–90d → amber (upcoming), >90d → neutral.
export function expiryTier(dateStr) {
  const days = daysToExpiry(dateStr)
  if (days == null) return null
  if (days < 0)   return { days, tier: 'overdue',  badge: 'badge-danger', label: `${Math.abs(days)}d overdue` }
  if (days <= 30) return { days, tier: 'urgent',   badge: 'badge-danger', label: `${days}d left` }
  if (days <= 90) return { days, tier: 'upcoming', badge: 'badge-warn',   label: `${days}d left` }
  return { days, tier: 'ok', badge: 'badge-gray', label: `${days}d` }
}
